<template>
  <Btn
    :variant="variant"
    :disabled="disabled"
    v-bind="$attrs"
    :title="title"
    :aria-label="title"
    @click="startCall"
  >
    <slot v-if="type === 'emergency'">
      <Icon id="alert" :scale="0.75" />
    </slot>
    <slot v-else>
      <Icon id="phone-up" :scale="0.75" class="mrgr--" />
      {{ $t('voip.call.call') }}
    </slot>
  </Btn>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { twilioConnection } from '@/services/twilio';
export default {
  props: {
    type: {
      type: String,
      default: null,
    },
    id: {
      // comma separated invitees
      type: String,
      required: true,
    },
    variant: {
      type: String,
      default: 'primary',
    },
  },

  computed: {
    ...mapState('voip', ['status', 'isCalling']),

    disabled() {
      if (this.type === 'emergency') {
        return this.status === 'unregistered';
      } else {
        return this.status !== 'registered';
      }
    },

    title() {
      if (this.type === 'emergency') {
        return this.$t('voip.call.emergency-call');
      } else {
        return this.$t('voip.call.call');
      }
    },
  },

  methods: {
    ...mapActions('voip', ['call', 'disconnectDevice']),

    startCall() {
      if (this.type === 'emergency' && twilioConnection) {
        this.disconnectDevice();
      }

      const invitees = this.id.split(',');
      this.call({ type: this.type, id: invitees }).then(
        () => {
          this.$emit('call-started');
        },
        error => {
          this.$notify({
            type: 'error',
            title: this.$t('voip.label'),
            text: error,
            duration: -1,
          });
        }
      );
    },
  },
};
</script>
